'use strict';

angular.module('clientDashboardApp').service('reviewService', function ($q, $http) {
  let canceler = null;

  const service = {
    getNetPromoterScore (params) {
      return $http
        .get(
          '/v5/netPromoterScore',
          {
            params,
          }
        )
        .then(response => response.data)
    },
    search (params) {
      if (canceler !== null) {
        canceler.resolve();
      }
      canceler = $q.defer()
      let queryParams = angular.extend(params, {format: "original"})

      return $http.get('/v5/reviews', {params: params, timeout: canceler.promise}).then(response => {
        canceler = null;
        return response.data;
      })
    },
    snapshotSummary (groupId) {
      var deferred = $q.defer();

      $http
        .get('/dashboard/reviewSummary/group/' + groupId)
        .success(function (data, status, headers, config) {
          deferred.resolve(data);
        })
        .error(function (data, status, headers, config) {
          deferred.reject('Error occurred while summary!');
        });

      return deferred.promise;
    },
    averageReviewByState(groupId) {
      return $http
        .get('/dashboard/stateSummary/group/' + groupId)
        .then((resp) => {
          return resp.data
        })
    },
    averageReviewByLocation(groupId) {
      return $http
        .get('/dashboard/stateSummary/group/' + groupId)
        .then((resp) => {
          return resp.data.byLocation
        })
    },
    generateReviewReport(params) {
      var deferred = $q.defer();

      //TODO any param validation
      $http
        .get('/v5/reviews/report', {
          params: params
        })
        .success(function (data, status, headers, config) {
          deferred.resolve(data);
        })
        .error(function (data, status, headers, config) {
          deferred.reject('Error occurred while summary!');
        });

      return deferred.promise;
    },

    exportReviews(params) {
      return $http.post('/v5/reviews/export', {}, {params}).then(response => response.data);
    },

    exportComparisonData(params) {
      return $http.post('/v5/reviews/comparisonReport/export', {}, {params}).then(response => response.data);
    },

    generateComparisonReport(params) {
      return $http.get('/v5/reviews/comparisonReport', {params}).then(response => response.data);
    },

    locationsComparisonReport(groupId, params) {
      return $http.get(`/v5/reviews/comparisonReport/${groupId}`, {params}).then(response => response.data);
    },

    locationComparisonReport(params) {
      return $http.get('/v5/reviews/locationsComparisonReport', {params}).then(response => response.data);
    },

    markReviewNotMine(reviewId) {
      return $http.post('/v5/reviews/' + reviewId + '/notMine', {reason: 'User requested removal'});
    },

    addReviewTag (reviewId, tag) {
      return $http.post(`/v5/reviews/${reviewId}/tag`, tag)
    },

    removeReviewTag (reviewId, tagId) {
      return $http.delete(`/v5/reviews/${reviewId}/tag/${tagId}`)
    },

    reaggregate(groupId) {
      return $http.get(`/v5/reviews/reaggregate/${groupId}`)
    },

    submitReviewResponse(reviewId, detail, isPublic) {
      return this.submitReviewResponses([{reviewId, detail, isPublic}])
        .then(results => {
          if (results["errors"].length > 0) {
            throw results["errors"][0]
          }

          return results["succeeded"][0]
        })
    },


    submitReviewResponses(instructions) {
      return $http.post(`/v5/reviews/responses`, {instructions})
        .then(response => response.data)
    },

    updateReviewResponse(reviewId, responseId, details, shouldSubmit) {
      return $http.post(`/v5/reviews/${reviewId}/responses/${responseId}`, {
        detail: details,
        submit: shouldSubmit,
        reviewId: reviewId
      }).then(response => response.data)
    },

    removeResponse(reviewId, responseId) {
      return $http.delete(`/v5/reviews/${encodeURIComponent(reviewId)}/responses/${encodeURIComponent(responseId)}`)
    }
  }

  window.reviewsService = service;

  return service

});
